export default function(arg, defaultValue = '') {
	// 如果值为'',null,undefined,NaN,返回defaultValue,否则返回原来值
	// 判断是否NaN 利用NaN为唯一不等于自身的值的这个特点
	if (arg === '' || arg === null || arg === undefined || (arg !== arg)) {
		return defaultValue
	} else {
		return arg
	}
}
